import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

function JobsTable({ jobs, shownRows }) {
    return (
        <div id="careers-jobs-list">
            {jobs.slice(0, shownRows).map((job) => (
                <div key={job.id} className="List__item">
                    <div className="grid">
                        <div className="grid--size12 grid--size5Tp offset--0 offset--1D List__column">
                            <strong>{job.name}</strong>
                        </div>
                        <div className="grid--size12 grid--size4Tp grid--size4D List__column">
                            {job.location}
                        </div>
                        <div className="grid--size12 grid--size3Tp grid--size2D List__column">
                            <Link to={job.url} className="List__itemButton">
                                <Button className="Buttons__button Button Button--background">Apply</Button>
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default JobsTable;